import { useEffect } from 'react'

export const useModalScrollBar = (isOpen?: boolean) => {
  useEffect(() => {
    if (
      document.documentElement.scrollHeight >
      document.documentElement.clientHeight
    ) {
      if (isOpen) {
        document.body.classList.add('has-modal')
      } else {
        setTimeout(() => {
          document.body.classList.remove('has-modal')
        }, 100)
      }
    }

    return () => {
      document.body.classList.remove('has-modal')
    }
  }, [isOpen])
}
